import React, { useEffect, useState } from "react";
import {
  doc,
  getDoc,
  setDoc,
  updateDoc,
  serverTimestamp,
  Timestamp,
} from "firebase/firestore";
import { db } from "../../../firebase";

interface SummaryEditProps {
  summaryId?: string; // 直接渡されたらそれを優先
  onBack: () => void;
}

const SummaryEdit: React.FC<SummaryEditProps> = ({ summaryId, onBack }) => {
  const currentYear = new Date().getFullYear().toString();
  const resolvedSummaryId = summaryId ?? currentYear;

  const [quartetSemiFinalAt, setQuartetSemiFinalAt] = useState("");
  const [quartetSemiFinalVenue, setQuartetSemiFinalVenue] = useState("");

  const [quartetFinalAt, setQuartetFinalAt] = useState("");
  const [quartetFinalVenue, setQuartetFinalVenue] = useState("");

  const [chorusFinalAt, setChorusFinalAt] = useState("");
  const [chorusFinalVenue, setChorusFinalVenue] = useState("");

  const [evaluationOnlyAt, setEvaluationOnlyAt] = useState("");
  const [evaluationOnlyVenue, setEvaluationOnlyVenue] = useState("");

  const [judgePanelADM, setJudgePanelADM] = useState("");
  const [judgePanelMUS, setJudgePanelMUS] = useState("");
  const [judgePanelPER, setJudgePanelPER] = useState("");
  const [judgePanelSNG, setJudgePanelSNG] = useState("");

  const [groupEntryStartAt, setGroupEntryStartAt] = useState("");
  const [groupEntryEndAt, setGroupEntryEndAt] = useState("");

  const [musicEntryStartAt, setMusicEntryStartAt] = useState("");
  const [musicEntryEndAt, setMusicEntryEndAt] = useState("");

  const [groupInfoEntryStartAt, setGroupInfoEntryStartAt] = useState("");
  const [groupInfoEntryEndAt, setGroupInfoEntryEndAt] = useState("");

  // =========================
  // fetch
  // =========================

  useEffect(() => {
    const fetchSummary = async () => {
      const docRef = doc(db, "summary", resolvedSummaryId);
      const snap = await getDoc(docRef);

      if (!snap.exists()) return;

      const data = snap.data();

      const convert = (t?: Timestamp) =>
        t ? t.toDate().toISOString().slice(0, 10) : "";

      setQuartetSemiFinalAt(convert(data.quartetSemiFinalAt));
      setQuartetSemiFinalVenue(data.quartetSemiFinalVenue || "");

      setQuartetFinalAt(convert(data.quartetFinalAt));
      setQuartetFinalVenue(data.quartetFinalVenue || "");

      setChorusFinalAt(convert(data.chorusFinalAt));
      setChorusFinalVenue(data.chorusFinalVenue || "");

      setEvaluationOnlyAt(convert(data.evaluationOnlyAt));
      setEvaluationOnlyVenue(data.evaluationOnlyVenue || "");

      setJudgePanelADM(data.judgePanelADM || "");
      setJudgePanelMUS(data.judgePanelMUS || "");
      setJudgePanelPER(data.judgePanelPER || "");
      setJudgePanelSNG(data.judgePanelSNG || "");

      setGroupEntryStartAt(convert(data.groupEntryStartAt));
      setGroupEntryEndAt(convert(data.groupEntryEndAt));

      setMusicEntryStartAt(convert(data.musicEntryStartAt));
      setMusicEntryEndAt(convert(data.musicEntryEndAt));

      setGroupInfoEntryStartAt(convert(data.groupInfoEntryStartAt));
      setGroupInfoEntryEndAt(convert(data.groupInfoEntryEndAt));
    };

    fetchSummary();
  }, [resolvedSummaryId]);

  // ===== Save =====

  const handleSave = async () => {
    if (!quartetSemiFinalAt) {
      alert("Quartet Semi Final 日付は必須です");
      return;
    }

    const year = new Date(quartetSemiFinalAt).getFullYear().toString();

    await setDoc(doc(db, "summary", year), {
      quartetSemiFinalAt: quartetSemiFinalAt
        ? Timestamp.fromDate(new Date(quartetSemiFinalAt))
        : null,

      quartetSemiFinalVenue,
      quartetFinalAt: quartetFinalAt
        ? Timestamp.fromDate(new Date(quartetFinalAt))
        : null,

      quartetFinalVenue,
      chorusFinalAt: chorusFinalAt
        ? Timestamp.fromDate(new Date(chorusFinalAt))
        : null,

      chorusFinalVenue,
      evaluationOnlyAt: evaluationOnlyAt
        ? Timestamp.fromDate(new Date(evaluationOnlyAt))
        : null,

      evaluationOnlyVenue,
      judgePanelADM,
      judgePanelMUS,
      judgePanelPER,
      judgePanelSNG,
      groupEntryStartAt: groupEntryStartAt
        ? Timestamp.fromDate(new Date(groupEntryStartAt))
        : null,

      groupEntryEndAt: groupEntryEndAt
        ? Timestamp.fromDate(new Date(groupEntryEndAt))
        : null,

      musicEntryStartAt: musicEntryStartAt
        ? Timestamp.fromDate(new Date(musicEntryStartAt))
        : null,

      musicEntryEndAt: musicEntryEndAt
        ? Timestamp.fromDate(new Date(musicEntryEndAt))
        : null,

      groupInfoEntryStartAt: groupInfoEntryStartAt
        ? Timestamp.fromDate(new Date(groupInfoEntryStartAt))
        : null,

      groupInfoEntryEndAt: groupInfoEntryEndAt
        ? Timestamp.fromDate(new Date(groupInfoEntryEndAt))
        : null,

      updatedAt: serverTimestamp(),
    });
  };

  return (
    <div className="table-contents">
      <p className="back" onClick={onBack}>
        ＜ 一覧に戻る
      </p>

      <div className="table-main">
        <div className="admin-edit entry-form">
          <div className="form-contents section-start">
            <label className="form-label">Quartet Semi Final</label>
          </div>
          <div className="form-contents middle-size">
            <label className="form-label">日付</label>
            <input
              type="date"
              value={quartetSemiFinalAt}
              onChange={(e) => setQuartetSemiFinalAt(e.target.value)}
            />
          </div>
          <div className="form-contents middle-size">
            <label className="form-label">会場</label>
            <input
              value={quartetSemiFinalVenue}
              onChange={(e) => setQuartetSemiFinalVenue(e.target.value)}
            />
          </div>
          <div className="form-contents section-start">
            <label className="form-label">Quartet Final </label>
          </div>
          <div className="form-contents middle-size">
            <label className="form-label">日付</label>
            <input
              type="date"
              value={quartetFinalAt}
              onChange={(e) => setQuartetFinalAt(e.target.value)}
            />
          </div>
          <div className="form-contents middle-size">
            <label className="form-label">会場</label>
            <input
              value={quartetFinalVenue}
              onChange={(e) => setQuartetFinalVenue(e.target.value)}
            />
          </div>
          <div className="form-contents section-start">
            <label className="form-label">Chorus</label>
          </div>
          <div className="form-contents middle-size">
            <label className="form-label">日付</label>
            <input
              type="date"
              value={chorusFinalAt}
              onChange={(e) => setChorusFinalAt(e.target.value)}
            />
          </div>
          <div className="form-contents middle-size">
            <label className="form-label">会場</label>
            <input
              value={chorusFinalVenue}
              onChange={(e) => setChorusFinalVenue(e.target.value)}
            />
          </div>
          <div className="form-contents section-start">
            <label className="form-label">Evaluation Onlys</label>
          </div>
          <div className="form-contents middle-size">
            <label className="form-label">日付</label>
            <input
              type="date"
              value={evaluationOnlyAt}
              onChange={(e) => setEvaluationOnlyAt(e.target.value)}
            />
          </div>
          <div className="form-contents middle-size">
            <label className="form-label">会場</label>
            <input
              value={evaluationOnlyVenue}
              onChange={(e) => setEvaluationOnlyVenue(e.target.value)}
            />
          </div>
          <div className="form-contents section-start">
            <label className="form-label">各種エントリー期間</label>
          </div>
          <div className="form-contents flex middle-size">
            <label className="form-label">団体エントリー</label>
            <input
              type="date"
              value={groupEntryStartAt}
              onChange={(e) => setGroupEntryStartAt(e.target.value)}
            />
            <label className="date-label">〜</label>
            <input
              type="date"
              value={groupEntryEndAt}
              onChange={(e) => setGroupEntryEndAt(e.target.value)}
            />
          </div>
          <div className="form-contents flex middle-size">
            <label className="form-label">演奏曲エントリー</label>
            <input
              type="date"
              value={musicEntryStartAt}
              onChange={(e) => setMusicEntryStartAt(e.target.value)}
            />
            <label className="date-label">〜</label>
            <input
              type="date"
              value={musicEntryEndAt}
              onChange={(e) => setMusicEntryEndAt(e.target.value)}
            />
          </div>
          <div className="form-contents flex middle-size">
            <label className="form-label">団情報</label>
            <input
              type="date"
              value={groupInfoEntryStartAt}
              onChange={(e) => setGroupInfoEntryStartAt(e.target.value)}
            />
            <label className="date-label">〜</label>
            <input
              type="date"
              value={groupInfoEntryEndAt}
              onChange={(e) => setGroupInfoEntryEndAt(e.target.value)}
            />
          </div>
          <div className="form-contents section-start">
            <label className="form-label">Judge Panel</label>
          </div>

          <div className="form-contents middle-size">
            <label className="form-label">ADM</label>
            <input
              value={judgePanelADM}
              onChange={(e) => setJudgePanelADM(e.target.value)}
            />
          </div>

          <div className="form-contents middle-size">
            <label className="form-label">MUS</label>
            <input
              value={judgePanelMUS}
              onChange={(e) => setJudgePanelMUS(e.target.value)}
            />
          </div>

          <div className="form-contents middle-size">
            <label className="form-label">PER</label>
            <input
              value={judgePanelPER}
              onChange={(e) => setJudgePanelPER(e.target.value)}
            />
          </div>

          <div className="form-contents middle-size">
            <label className="form-label">SNG</label>
            <input
              value={judgePanelSNG}
              onChange={(e) => setJudgePanelSNG(e.target.value)}
            />
          </div>
          <div className="edit-footer">
            <button onClick={handleSave}>保存する</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SummaryEdit;
